import { useId, useState } from 'react';
export default function Toggle({ name, label1, value1, label2, value2, selected, onChange }) {

    const [selectedValue, setSelected] = useState(selected);
    const toggleId = useId();

    return (
        <fieldset className="radio-toggle">
            <label className={value1 == selectedValue ? 'selected' : '' }>
                <input id={toggleId + value1} type="radio" name={name} value={value1} checked={value1 == selectedValue} onChange={() => { setSelected(value1); onChange(value1); }} />
                {label1}
            </label>
            <label className={value2 == selectedValue ? 'selected' : ''}>
                <input id={toggleId + value2} type="radio" name={name} value={value2} checked={value2 == selectedValue} onChange={() => { setSelected(value2); onChange(value2) }} />
                {label2}
            </label>
        </fieldset>
    );
}

